export const eventKeys = {
  click_reserve: 'asisonline_click_reserve',
  view_item: 'asisonline_view_item',
  reserve_successfully: 'asisonline_reserve_successfully',
  select_category: 'asisonline_select_category',
  search: 'asisonline_search',
  select_unit: 'asisonline_select_store',
  select_unit_manually: 'asisonline_select_store_manually',
  select_unit_automatically: 'asisonline_select_store_automatically',
  readmore_introduction: 'asisonline_readmore_introduction',
  readmore_instruction: 'asisonline_readmore_instruction',
  plp_show_more_button: 'asisonline_show_or_load_more',
  select_sorting: 'asisonline_sort',
  view_defects: 'asisonline_view_defects',
  hero_banner_readmore: 'hero-banner-readmore',
  hero_banner_buyback_link: 'hero-banner-buyback',
  click_grouped_item: 'asisonline_click_grouped_item',
} as const
